(function(){
  var d=document;
  d.documentElement.classList.add('tfl-js');
  function keepUtm(root){
    var q=location.search; if(!q) return;
    var keep=new URLSearchParams();
    new URLSearchParams(q).forEach(function(v,k){ if(/^utm_|^fbclid$|^gclid$|^ttclid$/.test(k)) keep.set(k,v); });
    if(![].concat(Array.from(keep.keys())).length) return;
    root.querySelectorAll('.tfl a[href]').forEach(function(a){
      if(a.dataset.tflUtm) return; a.dataset.tflUtm='1';
      var h=a.getAttribute('href');
      if(!h||h.charAt(0)==='#'||/^(mailto|tel):/.test(h)) return;
      try{ var u=new URL(a.href,location.origin); if(u.origin!==location.origin) return;
        keep.forEach(function(v,k){ if(!u.searchParams.has(k)) u.searchParams.set(k,v); });
        a.href=u.pathname+u.search+u.hash; }catch(e){}
    });
  }
  var io=('IntersectionObserver' in window)?new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
  },{rootMargin:'0px 0px -8% 0px'}):null;
  function reveal(root){
    root.querySelectorAll('.tfl-reveal:not([data-tfl-obs])').forEach(function(el){
      el.setAttribute('data-tfl-obs','1');
      if(io && !(window.Shopify && Shopify.designMode)) io.observe(el); else el.classList.add('is-in');
    });
  }
  function swipes(root){
    root.querySelectorAll('[data-tfl-swipe]:not([data-tfl-sw])').forEach(function(row){
      row.setAttribute('data-tfl-sw','1');
      var bar=row.parentNode.querySelector('.tfl-swipe-hint i span'); if(!bar) return;
      function upd(){ var max=row.scrollWidth-row.clientWidth, vis=row.clientWidth/row.scrollWidth;
        bar.style.width=Math.max(vis*100,12)+'%';
        bar.style.transform='translateX('+(max>0?row.scrollLeft/max*(1/Math.max(vis,.12)-1)*100:0)+'%)'; }
      row.addEventListener('scroll',upd,{passive:true}); window.addEventListener('resize',upd); upd();
    });
  }
  function init(root){ root=root||d; keepUtm(root); reveal(root); swipes(root); }
  if(window.__tbgAuLpInit) return; window.__tbgAuLpInit=true;
  if(d.readyState!=='loading') init(); else d.addEventListener('DOMContentLoaded',function(){init();});
  d.addEventListener('shopify:section:load',function(e){ init(e.target); });
})();
